import React from "react";

import { SyncIcon } from "assets";
import "./RefreshButton.scss";

export interface IRefreshButtonProps {
  title?: string;
  onClick?(): void;
}

const RefreshButton: React.FC<React.PropsWithChildren<IRefreshButtonProps>> = ({
  title,
  onClick,
}) => {
  return (
    <button
      className="c-refresh-button"
      title={title}
      onClick={onClick}
      tabIndex={0}
    >
      <SyncIcon width={30} height={30} />
    </button>
  );
};

export default RefreshButton;
